import Rest from '../Rest'

export default class RentalSpaceService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/rental_spaces'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  findAllCategories() {
    return this.get('/categories')
  }

  updateSchedule(id: number, scheduleData: any) {
    return this.put(`/${id}/schedules`, scheduleData)
  }

  findAllSchedules(id: number) {
    return this.get(`/${id}/schedules`)
  }
}
